import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormSignatureComponent } from '../../../items/form-signature.component';

// 參與者簽名資料介面
export interface ParticipantSignature {
  id: string;
  name: string;
  title?: string;
  department?: string;
  signature: string | null;
  signedAt?: Date;
}

@Component({
  selector: 'app-meeting-signature-collection',
  templateUrl: './meeting-signature-collection.component.html',
  styleUrls: ['./meeting-signature-collection.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, FormSignatureComponent]
})
export class MeetingSignatureCollectionComponent implements OnInit {
  @Input() documentId: string = 'meeting_safety_20251015';
  @Input() title: string = '安全宣導會議簽到表';
  @Output() signaturesUpdated = new EventEmitter<ParticipantSignature[]>();

  // 參與者清單
  participants: ParticipantSignature[] = [];

  // 新參與者資訊
  newParticipant = {
    name: '',
    title: '',
    department: ''
  };

  constructor() {}

  ngOnInit(): void {
    // 載入預設參與者或從服務獲取
    this.loadParticipants();
  }

  // 載入參與者
  loadParticipants(): void {
    // 這裡可以從服務獲取預定參與者，或使用預設值
    this.participants = [
      {
        id: this.generateId(),
        name: '張三',
        title: '部門主管',
        department: '研發部',
        signature: null
      },
      {
        id: this.generateId(),
        name: '李四',
        title: '安全衛生管理師',
        department: '環安衛部',
        signature: null
      }
      // 可加入更多預設參與者
    ];
  }

  // 生成唯一ID
  generateId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  // 簽名變更處理
  onSignatureChange(value: string | null, participantId: string): void {
    const index = this.participants.findIndex(p => p.id === participantId);
    if (index !== -1) {
      this.participants[index].signature = value;
      if (value) {
        this.participants[index].signedAt = new Date();
      } else {
        this.participants[index].signedAt = undefined;
      }

      // 通知父元件簽名已更新
      this.signaturesUpdated.emit([...this.participants]);
    }
  }

  // 新增參與者
  addParticipant(): void {
    if (!this.newParticipant.name.trim()) {
      alert('請輸入參與者姓名');
      return;
    }

    const participant: ParticipantSignature = {
      id: this.generateId(),
      name: this.newParticipant.name,
      title: this.newParticipant.title || undefined,
      department: this.newParticipant.department || undefined,
      signature: null
    };

    this.participants.push(participant);

    // 重置表單
    this.newParticipant = {
      name: '',
      title: '',
      department: ''
    };

    // 通知父元件簽名已更新
    this.signaturesUpdated.emit([...this.participants]);
  }

  // 刪除參與者
  removeParticipant(participantId: string): void {
    const index = this.participants.findIndex(p => p.id === participantId);
    if (index !== -1) {
      if (confirm(`確定要移除 ${this.participants[index].name} 的簽名欄位嗎？`)) {
        this.participants.splice(index, 1);

        // 通知父元件簽名已更新
        this.signaturesUpdated.emit([...this.participants]);
      }
    }
  }

  // 獲取已簽名人數
  get signedCount(): number {
    return this.participants.filter(p => p.signature !== null).length;
  }

  // 獲取總人數
  get totalCount(): number {
    return this.participants.length;
  }
}
